import { Spacing } from '../css/baseStyles';

export function getWebviewHorizontalMarginValue(
  horizontalMargin: number,
  isTablet: boolean,
  extraMarginModifier = 0,
): number {
  const tabletMargin = Math.floor(Spacing.baseHorizontalMargin + horizontalMargin + extraMarginModifier);
  const phoneMargin = Math.floor(Math.max(Spacing.baseHorizontalMargin + extraMarginModifier, 0));

  return isTablet ? tabletMargin : phoneMargin;
}

export default function getWebviewHorizontalMarginCss(
  horizontalMargin: number,
  isTablet: boolean,
  extraMarginModifier = 0,
) {
  const margin = getWebviewHorizontalMarginValue(horizontalMargin, isTablet, extraMarginModifier);

  return {
    css: `.digest-content, .rw-chunk-container, .snapshot-content, .header-content, #end-of-content { padding-left: ${margin}px!important; padding-right: ${margin}px!important}`,
    margin,
  };
}
